export default {"src":"/_next/static/media/LinkChainGrey.27162fb9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};